export default __webpack_public_path__ + "static/media/klarge.35ec1398.jpg";